import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Spinner from './components/Spinner';
import Editor from './components/EDITOR/Editor';
import ViewPost from './components/VIEW/ViewPost';
import ViewAllPosts from './components/VIEW/ViewAllPosts';
import PortfolioPage from './components/PORTFOLIO/PortfolioPage';
import './index.css';
import { Route, BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';

const routing = (
  <Router>
    <div>
      <Route exact path="/" component={App} />
      <Route path="/spinner" component={Spinner} />
      <Route path="/editXXX" component={Editor} />
      <Route path="/allPosts" component={ViewAllPosts}/>
      <Route path="/view:id" component={ViewPost} />
      <Route path="/portfolio-ujjwal" component={PortfolioPage} />
    </div>
  </Router>
)

ReactDOM.render(
  <Provider store={store}>
  {routing}
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js